import React from 'react';
import {
  CheckoutUserDataConnectorApollo,
  SalePaymentSaveConnectorApollo,
} from '@front-activerse/common-components';
import SavePaymentContainer from './SavePaymentContainer';

interface ISavePaymentPage {
  pathPaymentMethods: string;
}

const SavePaymentPage: React.FC<ISavePaymentPage> = ({ pathPaymentMethods }) => {
  const tokenFromLocalStorage = localStorage.getItem('shoppingCartToken') || '';

  return (
    <div>
      {tokenFromLocalStorage && (
        <CheckoutUserDataConnectorApollo>
          {({ ...userData }) => (
            <SalePaymentSaveConnectorApollo>
              {({ savePayment, loading }) => {
                return (
                  <SavePaymentContainer
                    {...userData}
                    loading={userData.loading || loading}
                    shoppingCartToken={tokenFromLocalStorage}
                    pathPaymentMethods={pathPaymentMethods}
                    savePayment={savePayment}
                  />
                );
              }}
            </SalePaymentSaveConnectorApollo>
          )}
        </CheckoutUserDataConnectorApollo>
      )}
    </div>
  );
};

export default SavePaymentPage;
